import Registry from 'registry';
import { Frontload } from 'react-frontload'
import { ToastContainer } from 'react-toastify';
import { LastLocationProvider } from 'react-router-last-location';

import 'react-toastify/dist/ReactToastify.min.css';

import configDefault from '../app-config.default';

if (window.__appConfig) {
    Registry.add(Object.assign({}, configDefault, window.__appConfig));
}

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router, Route, Switch} from 'react-router';
import {ConnectedRouter} from 'connected-react-router';
import {createStore, applyMiddleware, compose} from 'redux';

import createLogger from 'redux-logger';

let _debug = false;
let _debugMatch = window.location.hash.match(/debug=(\d+)/);
if (_debugMatch && _debugMatch[1] == '1') {
    _debug = true;
}
if (document.cookie.match(/debug=1/)) {
    _debug = true;
}

import * as l10n from 'l10n';
import frLocale from './l10n-messages/fr/index';

l10n.addLocale(frLocale, 'fr');

import reducers from './reducers/index';

// middleware
import promiseMiddleware from './middleware/promiseMiddleware';
import authTokenMiddleware from './middleware/authToken';
import logoutSyncMiddleware from './middleware/logoutSyncMiddleware';
import socketMiddleware from './middleware/socketMiddleware';

import pmJsMiddleware from 'pm-js/build/middleware/pmMiddleware';
//import pmJsMiddleware from 'local-pm-js/build/middleware/pmMiddleware';
import visibilityEventSource from './middleware/visibilityMiddleware';



import pmJsStartup from './middleware/hitagiMiddleware';
import firebaseMiddleware from './middleware/firebaseMiddleware';

let middleware = [
    promiseMiddleware,
    authTokenMiddleware,
    logoutSyncMiddleware,
    socketMiddleware,
    pmJsMiddleware,
    pmJsStartup,
    firebaseMiddleware,
];

if (_debug) {
    // logger
    let REDUX_LOGGER_OPTS = Registry.get('REDUX_LOGGER_OPTS');
    const reduxLoggerOpts = REDUX_LOGGER_OPTS || {duration: true};
    const logger = createLogger(reduxLoggerOpts);

    middleware.push(logger);

}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

import {BobTVUser} from 'bobtvuser';

let preloadedState = window.__preloadedState || {};
if (preloadedState.currentUser) {
    preloadedState.currentUser = new BobTVUser(preloadedState.currentUser);
} else {
    preloadedState.currentUser = new BobTVUser({});
}

import {getFromPersistent as getAuthTokenFromPersistent} from 'reducers/authToken';
import {setAuthTokenData} from 'backend-helpers/member';

let storedAuthTokenData = getAuthTokenFromPersistent();
if (typeof storedAuthTokenData === 'object') {
    setAuthTokenData(storedAuthTokenData);
    preloadedState.authToken = storedAuthTokenData;
}

// history
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

//store
let store = createStore(reducers(history), preloadedState, composeEnhancers(
// let store = createStore(reducers, preloadedState,
    applyMiddleware(...middleware)
)); 

visibilityEventSource(store);

import AppContainer from 'components/AppContainer';

// todo: react-router-scroll

import routes from './routes';

const toastifyConfig = {
    position: 'bottom-right',
    newestOnTop: true,
    autoClose: false,
    closeButton: false,
};

function LangSwitcher(props) {
    let {lang, routes} = props;
    l10n.setLocale(lang);

    let langPrefix = l10n.getLangPrefix(lang);

    return (
        <AppContainer>
            <Switch>{/* <Switch> requires only <Route>`s as its children */}
                {routes.map((props, index) => {
                    let {path, children, ...rest} = props;
                    return <Route path={path && langPrefix + path} {...rest} key={index}>{children}</Route>
                })}
            </Switch>
            <ToastContainer {...toastifyConfig} />
        </AppContainer>
    );
}


import postRender from 'postRender';

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Router history={history}>
                <LastLocationProvider>
                    <Frontload>
                        <Switch>
                            <Route path='/en' render={(props) => LangSwitcher({...props, routes: routes, lang: 'en'})}/>
                            <Route path='/' render={(props) => LangSwitcher({...props, routes: routes, lang: 'fr'})}/>
                        </Switch>
                    </Frontload>
                </LastLocationProvider>
            </Router>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
    function() {
        postRender(store)
    }
);



// WEBPACK FOOTER //
// ./src/client.js